/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

type Props = {
  className: string;
  cardHeight?: string;
};

const ListUsersSessionSeller: React.FC<Props> = ({ className, cardHeight }) => {
  return (
    <div className="mb-5 mb-xl-8 w-100" style={{ height: cardHeight }}>
      <div className="card-body pt-0 overflow-auto">
        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-warning me-5">
            <img
              id="imgUsersBlack"
              src="/media/avatars/300-1.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6">Roberto Adams</p>
          </div>
          <span className="fw-bold  text-danger py-1">R$ 3,00</span>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-dark me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-3.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6">Ruan</p>
          </div>
          <span className="fw-bold py-1">R$ 0,00</span>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-danger me-5">
            <img
              id="imgUsersStudent"
              src="/media/avatars/300-7.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6">Rodrigo</p>
          </div>
          <span className="fw-bold  text-danger py-1">R$ 15,00</span>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-primary me-5">
            <img
              id="imgUsersBusiness"
              src="/media/avatars/300-9.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6">Ronã</p>
          </div>
          <span className="fw-bold py-1">R$ 0,00</span>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-warning me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-11.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6 ">Carlos</p>
          </div>
          <span className="fw-bold  text-danger py-1">R$ 3,00</span>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-danger me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-1.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6">
              Adriano Strack
            </p>
          </div>
          <span className="fw-bold  text-danger py-1">R$ 15,00</span>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-primary me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-2.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold text-hover-primary m-0 fs-6">
              Maria Oliveira
            </p>
          </div>
          <span className="fw-bold  text-danger py-1">R$ 9,00</span>
        </div>
      </div>
    </div>
  );
};

export { ListUsersSessionSeller };
